<template>
  <div>
    <input type="text" className="form-control" placeholder="" v-model="propsValue">

      <div class="row">
        <div class="col-3">
          <BasicInfo></BasicInfo>

        </div>
        <div class="col-6">
          <DepUrology v-if="dep==='DepUrology'"></DepUrology>
          <DepNeurosurgery v-if="dep==='DepNeurosurgery'"></DepNeurosurgery>

          <DepOrthopedics v-if="dep==='DepOrthopedics'"></DepOrthopedics>
          <DepRehabiltation v-if="dep==='DepRehabiltation'"></DepRehabiltation>
          <DepTraditionalChineseMedicine v-if="dep==='DepTraditionalChineseMedicine'"></DepTraditionalChineseMedicine>
          <DepDental v-if="dep==='DepDental'"></DepDental>
          <DepPlasticSurgery v-if="dep==='DepPlasticSurgery'"></DepPlasticSurgery>
        </div>
        <div class="col-3">
          <Medicine></Medicine>
        </div>
      </div>


  </div>
</template>

<script>/**

 **/
import BasicInfo from "@/views/rcc/component/BasicInfo.vue";
import DepUrology from "@/views/rcc/component/DepUrology.vue";
import DepNeurosurgery from "@/views/rcc/component/DepNeurosurgery.vue";
import Medicine from "@/views/rcc/component/Medicine.vue";
import DepOrthopedics from "@/views/rcc/component/DepOrthopedics.vue";
import DepRehabiltation from "@/views/rcc/component/DepRehabiltation.vue";
import DepTraditionalChineseMedicine from "@/views/rcc/component/DepTraditionalChineseMedicine.vue";
import DepPlasticSurgery from "@/views/rcc/component/DepPlasticSurgery.vue";
import DepDental from "@/views/rcc/component/DepDental.vue";


export default {
  components: {
    DepDental,
    DepPlasticSurgery,
    DepTraditionalChineseMedicine,
    DepRehabiltation, DepOrthopedics, Medicine, DepNeurosurgery, DepUrology, BasicInfo},
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
      dep:"",
    };
  },
  watch: {
    propsValue(newVal) {
      //this.('input', newVal);
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
  },
  mounted() {
    // this.initValue()
    //this.loadData()
    this.dep=this.$route.query.dep
  },
}
</script>

<style scoped>

</style>
